import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRoutes } from '../api-routes';
import { Globals } from '../global';
import { ApiCallingService } from './api-calling-service';
// import { sharedBroadcast } from '../../pages/header/header';
@Injectable({
  providedIn: 'root',
})
export class idleService {
  private sharedBroadcast = new BroadcastChannel('auth_channel');
  toastMessageSignal = signal<any | null>(null);
  private inactivityTime = 0;
  private readonly inactivityTimeout = 60 * 60 * 1000; // 1 hour
  private idleInterval: any;
  private readonly AUTO_LOGOUT_TIME = 10 * 60 * 60 * 1000; // 10 hours
  private autoLogoutTimer: any;
  private ssoTokenExpiryTimer: any;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private globals: Globals
  ) {
    this.sharedBroadcast.onmessage = (message) => {
      // Support both object messages ({ type: 'logOut' }) and string messages ('logOut')
      const type = typeof message.data === 'string' ? message.data : message.data?.type;

      switch (type) {
        case 'logOut':
          this.toastMessageSignal.set({
            severity: 'success',
            summary: 'Logout',
            detail: 'You have Logged Out Successfully.',
          });

          window.location.reload();

          break;

        case 'logOut-noActivity':
          this.toastMessageSignal.set({
            severity: 'success',
            summary: 'Logout',
            detail: 'You have been forcefully logged out. Please log in again.',
          });
          if ('caches' in window) {
            caches.keys().then((names) => {
              names.forEach((name) => caches.delete(name));
              window.location.reload();
            });
          }
          break;

        case 'logOut-inter':
          this.toastMessageSignal.set({
            severity: 'success',
            summary: 'Logout',
            detail: 'You have been forcefully logged out. Please log in again.',
          });
          window.location.reload();
          break;

        case 'resetInactivityTimer':
          this.resetInactivityTimer();
          break;

        case 'login':
          window.location.reload();
          break;

        default:
          console.warn('Unhandled message:', message.data);
      }
    };

    this.attachActivityListeners();
  }

  //////code for auto logout  //////////////////
  private attachActivityListeners(): void {
    ['mousemove', 'keydown', 'click', 'scroll'].forEach((evt) => {
      window.addEventListener(evt, () => this.resetInactivityTimer());
    });
  }

  public startInactivityTimer(): void {
    if (this.idleInterval) clearInterval(this.idleInterval);

    this.idleInterval = setInterval(() => {
      this.inactivityTime += 60 * 1000;
      if (this.inactivityTime >= this.inactivityTimeout) {
        clearInterval(this.idleInterval);
        this.logout('noActivity');
      }
    }, 60 * 1000);
  }

  private resetInactivityTimer(): void {
    if (this.inactivityTime > 0) {
    }
    this.inactivityTime = 0;
  }

  public stopInactivityTimer(): void {
    if (this.idleInterval) {
      clearInterval(this.idleInterval);
      this.idleInterval = null;
    }
  }

  broadcastMessage(Type: string) {
    this.sharedBroadcast.postMessage({ type: Type });
  }

  private clearAppSessionOnly(): void {
    localStorage.removeItem('isUserLogged');
    localStorage.removeItem('Auth_token');
    localStorage.removeItem('Auth-user');
    localStorage.removeItem('accessPage');
    localStorage.removeItem('userLoginDateTime');
    localStorage.removeItem('ssologin');
    localStorage.removeItem('languageId');
    localStorage.removeItem('defaultPage');
    localStorage.removeItem('loginWith');
    localStorage.removeItem('ssoTokenExpiresAt');
    localStorage.removeItem('ssoTokenExpiresIn');
    sessionStorage.removeItem('msal_prompt_none_tried');
    localStorage.removeItem('pageTourHighlightedPages');

    this.clearSsoTokenExpiryTimer();
    this.clearAutoLogoutTimer();
    this.stopInactivityTimer();
  }

  logout(type: string = '') {
    const originEntityId = this.globals.getUserInfo()?.originEntityId || 'MQ==';
    this.apiCallingService
      .callAuthPostAPI(
        { originEntityId: this.globals.encryptValue(originEntityId) },
        'PUT',
        ApiRoutes.URLS.LOGOUT
      )
      .subscribe({
        next: (response: any) => {
          response = typeof response === 'string' ? JSON.parse(response) : response;
          if (response.responseCode == 200) {
            this.clearAppSessionOnly();

            if (type && type === 'noActivity') {
              this.toastMessageSignal.set({
                severity: 'success',
                summary: 'Logout',
                detail: 'You have been forcefully logged out. Please log in again.',
              });
              this.broadcastMessage('logOut-noActivity');
              this.router.navigate(['/login']).then(() => {
                this.clearAppSessionOnly();
                if ('caches' in window) {
                  caches.keys().then((names) => {
                    names.forEach((name) => caches.delete(name));
                  });
                  window.location.reload();
                }
              });
            } else {
              let detail = '';

              if (type === 'ssoTokenExpired') {
                detail = 'Your Microsoft SSO session has expired. Please log in again.';
              } else if (type === 'Unauthorized') {
                detail = 'You have been forcefully logged out. Please log in again.';
              } else {
                detail =
                  response.responseMessage?.charAt(0).toUpperCase() +
                  response.responseMessage?.slice(1).toLowerCase();
              }

              this.toastMessageSignal.set({
                severity: type === 'ssoTokenExpired' ? 'warn' : 'success',
                summary: type === 'ssoTokenExpired' ? 'Session Expired' : 'Logout',
                detail,
              });

              this.broadcastMessage('logOut');
              this.router.navigate(['/login']);
            }
          }
        },
        error: (error: any) => {
          let err = typeof error.error === 'string' ? JSON.parse(error.error) : error.error;
          if (err?.responseCode === 401) {
            this.broadcastMessage('logOut');
            this.clearAppSessionOnly();
            this.router.navigate(['/login']);
          } else {
            this.toastMessageSignal.set({
              severity: 'error',
              summary: 'Error',
              detail:
                err?.responseMessage?.charAt(0).toUpperCase() +
                err?.responseMessage?.slice(1).toLowerCase(),
            });
          }
        },
      });
  }

  startAutoLogoutFromLoginTime(): void {
    const loginTimeStr = localStorage.getItem('userLoginDateTime');
    if (!loginTimeStr) return;

    const loginTime = Number(loginTimeStr);
    const elapsedTime = Date.now() - loginTime;
    const remainingTime = this.AUTO_LOGOUT_TIME - elapsedTime;

    if (this.autoLogoutTimer) {
      clearTimeout(this.autoLogoutTimer);
    }

    if (remainingTime <= 0) {
      this.logout();
    } else {
      this.autoLogoutTimer = setTimeout(() => {
        this.logout();
      }, remainingTime);
    }
  }

  clearAutoLogoutTimer(): void {
    if (this.autoLogoutTimer) {
      clearTimeout(this.autoLogoutTimer);
      this.autoLogoutTimer = null;
    }
  }

  /**
   * Helper to read expiresOn directly from MSAL's accesstoken in localStorage
   */
  getMsalTokenExpiresOnSec(): number | null {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.includes('accesstoken')) {
        try {
          const item = JSON.parse(localStorage.getItem(key) || '{}');
          if (item.expiresOn) {
            const n = Number(item.expiresOn);
            return n > 1e12 ? Math.floor(n / 1000) : n;
          }
        } catch (e) {
          // ignore parse errors
        }
      }
    }
    return null;
  }

  /**
   * Start auto-logout based on Microsoft access token expiry.
   * @param expiresInSeconds Optional duration in seconds (e.g. 3872)
   */
  startSsoTokenExpiryLogout(expiresInSeconds?: number): void {
    this.clearSsoTokenExpiryTimer();

    let sec = expiresInSeconds;

    // Fallback: Read directly from MSAL localStorage if not provided
    if (!sec) {
      const expiresOnSec = this.getMsalTokenExpiresOnSec();
      if (expiresOnSec) {
        sec = Math.floor(expiresOnSec - Date.now() / 1000);
      }
    }

    if (!sec || sec <= 0) {
      console.warn('[SSO] Invalid or expired token duration, skip token expiry logout');
      return;
    }

    // Logout 60 seconds before actual token expiry
    const bufferSec = 60;
    const logoutAfterMs = Math.max((sec - bufferSec) * 1000, 5 * 1000);
    const expiresAt = Date.now() + sec * 1000;

    localStorage.setItem('ssoTokenExpiresAt', expiresAt.toString());
    localStorage.setItem('ssoTokenExpiresIn', sec.toString());

    console.log(
      `[SSO] Access token expires in ${sec}s. Auto-logout scheduled in ${Math.floor(
        logoutAfterMs / 1000
      )}s`
    );

    this.ssoTokenExpiryTimer = setTimeout(() => {
      console.warn('[SSO] Access token expired → auto logout');
      this.logout('ssoTokenExpired');
    }, logoutAfterMs);
  }

  /**
   * If page refreshed while SSO logged in, resume expiry timer from saved timestamp or MSAL cache.
   */
  resumeSsoTokenExpiryLogoutIfNeeded(): void {
    const isSso = localStorage.getItem('ssologin') === 'true';
    const isLoggedIn =
      localStorage.getItem('isUserLogged') === 'true' && !!localStorage.getItem('Auth_token');

    if (!isSso || !isLoggedIn) return;

    const expiresAtStr = localStorage.getItem('ssoTokenExpiresAt');

    // If timestamp is missing, try reading from MSAL localStorage cache directly
    if (!expiresAtStr) {
      this.startSsoTokenExpiryLogout();
      return;
    }

    const expiresAt = Number(expiresAtStr);
    const remainingMs = expiresAt - Date.now() - 60 * 1000; // 60s buffer

    this.clearSsoTokenExpiryTimer();

    if (remainingMs <= 0) {
      console.warn('[SSO] Token already expired on resume → logout');
      this.logout('ssoTokenExpired');
      return;
    }

    console.log(`[SSO] Resuming token expiry logout in ${Math.floor(remainingMs / 1000)}s`);
    this.ssoTokenExpiryTimer = setTimeout(() => {
      this.logout('ssoTokenExpired');
    }, remainingMs);
  }

  clearSsoTokenExpiryTimer(): void {
    if (this.ssoTokenExpiryTimer) {
      clearTimeout(this.ssoTokenExpiryTimer);
      this.ssoTokenExpiryTimer = null;
    }
  }
}